var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "history-map-container" },
    [
      _c("div", { staticClass: "history-map-title" }, [
        _c("div", [_vm._v(_vm._s(_vm.title))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "history-map" }, [
        _vm._v("map component - " + _vm._s(_vm.title)),
      ]),
      _vm._v(" "),
      _c("history-map-legend", {
        attrs: { "selected-items": _vm.legendItems },
      }),
      _vm._v(" "),
      _vm.subtext
        ? _c("div", { staticClass: "history-content history-map-subtext" }, [
            _vm._v(_vm._s(_vm.subtext)),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }